
export enum StereotypeErrorCode {
    CONFLICTING_NAME = "CONFLICTING_NAME",
    CONFLICTING_IDENTIFIER = "CONFLICTING_IDENTIFIER",
    INVALID_IDENTIFIER_FORMAT = "INVALID_IDENTIFIER_FORMAT",
}